<template>
  <Activity :title="t('app.main.title')" vertical="center">
    <home-buttons :items="buttons"/>
  </Activity>
</template>

<script>

import Activity from "@/app/components/Activity.vue";
import HomeButtons from "@/app/components/home/HomeButtons.vue";

export default {
  components: {Activity, HomeButtons},

  setup() {
    // eslint-disable-next-line no-undef
    const { t } = useI18n()

    return {
      t,
    }
  },

  // not possible to use translations in setup()
  computed: {
    buttons() {
      return [
        // { label: this.$t('app.main.button.report'),
        //   route: { name: 'DeliveryReportActivity' },
        //   disabled: true,
        //   image: 'report.png'},
        { label: this.$t('app.main.button.deliveries.pigsty'),
          route: { name: 'DeliveryListActivity', params: { context: 'pigSty' } },
          image: 'deliveries.png'},
        { label: this.$t('app.main.button.deliveries.piglet'),
          route: { name: 'DeliveryListActivity', params: { context: 'piglet' } },
          image: 'deliveries.png'},
        // { label: this.$t('app.main.button.animal'),
        //   disabled: true, },
        // { label: this.$t('app.main.button.company'),
        //   disabled: true },
        // { label: this.$t('app.main.button.reports'),
        //   disabled: true, },
        // { label: this.$t('app.main.button.protocols'),
        //   disabled: true, },
      ]
    }
  }
}
</script>
